import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import strings from "../global/strings";

interface UploadImageVars {
	image: File;
	id: string | number;
	type: string;
}

// The three id-able image targets multer.controller.js's uploadImage handles
// (billing_system_BE) — each branch returns only its own field, never a mix.
export interface UploadImageResult {
	success: boolean;
	message?: string;
	result?: {
		customer_image?: string;
		user_image?: string;
		company_logo?: string;
	};
}

async function postUploadImage({
	image,
	id,
	type,
}: UploadImageVars): Promise<UploadImageResult> {
	const data = new FormData();
	data.append("image", image);
	data.append("id", String(id));
	data.append("type", type);

	const res = await axios.post(`${strings.url}multer/image/upload`, data, {
		headers: { "Content-Type": "multipart/form-data" },
		withCredentials: true,
	});

	if (!res.data.success) {
		throw new Error(res.data.message);
	}

	return res.data;
}

export function useUploadImage() {
	return useMutation({
		mutationFn: postUploadImage,
	});
}
